import { render, staticRenderFns } from "./OrderMailButton.vue?vue&type=template&id=2a174f0b&scoped=true&"
import script from "./OrderMailButton.vue?vue&type=script&lang=ts&"
export * from "./OrderMailButton.vue?vue&type=script&lang=ts&"
import style0 from "./OrderMailButton.vue?vue&type=style&index=0&id=2a174f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a174f0b",
  null
  
)

export default component.exports